import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyCheckReportState } from '../novelty-check-report-state';
import type { NoveltyCheckReportContext } from '../novelty-check-report-context';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { Logger } from '@patsnap/tahiti-core';
import { RetrievalResultReportModel } from '@/domains/novelty-check-report/models/retrieval-result-report-model';
import { TechEssentialService } from '../../retrieval-result-report-service';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';

@injectable()
export class SearchInputState implements NoveltyCheckReportState {
    // eslint-disable-next-line max-params
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(RetrievalResultReportModel)
        private readonly _retrievalResultReportModel: RetrievalResultReportModel,
        @inject(TechEssentialService)
        private readonly _techEssentialService: TechEssentialService,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
    ) { }

    async enter(): Promise<void> {
        this._logger.info('进入编辑技术要点状态');
        this._switchTaskStep(NoveltyCheckTaskStep.NOVELTY_SEARCH_INPUT);
        // 获取之前的查新输入
        const techEssential = this._retrievalResultReportModel.modelData.techEssential;
        // 填充
        this._retrievalResultReportModel.update((model) => {
            model.techEssential = techEssential;
            return model;
        });
    }

    /**
     * 切换任务步骤
     * @param step 目标步骤
     */
    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        // 从 retrievalResultReportModel 中获取技术要点
        const techEssential = this._retrievalResultReportModel.modelData.techEssential;
        // 更新技术要点
        await this._techEssentialService.updateTechEssential(techEssential);

        // 从编辑技术要点状态进入技术特征识别状态
        const summaryState = context.getState(NoveltyCheckTaskStep.SUMMARY);
        context.transitionTo(summaryState);
    }

    async handlePrevious(context: NoveltyCheckReportContext): Promise<void> {
        const summaryState = context.getState(NoveltyCheckTaskStep.SUMMARY);
        await context.transitionTo(summaryState);
    }
}
